import MessageViewer from "./common/message.js";

export default {
    tags        : [ "Message" ],
    name        : "message_create",
    viewer      : MessageViewer,

    definition: (i18n, log) => {
        return i18n("logs_definition.message_create");
    },

    filter: {
        icon: "chat",
        name: (i18n) => "Envoi de message",
    },
}
